export default __webpack_public_path__ + "images/bl-6a6bc7f183b774316b63325b5e8ae296.svg";